import { lowerCase, startCase } from 'lodash';
import { compose, mapValues as mapValuesFP, invertObj } from 'lodash/fp';

export default compose(
  mapValuesFP(compose(startCase, lowerCase)),
  invertObj,
);
